export default "__VITE_ASSET__7b4301a2__"